var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCalendar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 19,
    viewBox: "0 0 19 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.89209 2V4.25",
    stroke: "#A461D8",
    strokeWidth: 1.22727,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.8921 2V4.25",
    stroke: "#A461D8",
    strokeWidth: 1.22727,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M3.14209 6.39773C3.14209 4.59025 4.60734 3.125 6.41482 3.125H13.3694C15.1768 3.125 16.6421 4.59025 16.6421 6.39773V13.7273C16.6421 15.5347 15.1768 17 13.3694 17H6.41482C4.60734 17 3.14209 15.5347 3.14209 13.7273V6.39773Z",
    stroke: "#A461D8",
    strokeWidth: 1.22727
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M7.64209 11.75L8.90576 12.7609C9.24766 13.0345 9.7443 12.9903 10.0326 12.6608L12.1421 10.25",
    stroke: "#A461D8",
    strokeWidth: 1.22727,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M3.14209 7.25H16.6421",
    stroke: "#A461D8",
    strokeWidth: 1.22727,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendar);
export default __webpack_public_path__ + "static/media/calendar.330ab01e6665c91a6cba3f5521225b84.svg";
export { ForwardRef as ReactComponent };